import Row from "../../utils/row";
import List from "../list/list";

export default function LabelContainer({
    children,
    label,
    description,
    placeholder,
    className = '',
    grow = false,
    fill = false,
    fontSize = '14px' ,
    color = 'black',
    fontWeight = '400',
    gap = '20px',
    style = {},
    height,
    required = false,
}) {
    return (
        <div className={`label-container ${className}`} style={{
            width: fill ? '100%' : 'inherit',
            flexGrow: grow ? grow : '',
            height,
            ...style,
        }}>
            <List gap={gap} height={height}>
                <List gap="20px">
                    { label && <Row gap="5px" alignItems="center">
                        { required && <p style={{ fontSize: '12px', fontWeight: '500', color: '#f48181' }}>*</p> }
                        <label style={{ fontSize, color, fontWeight }}>{ label }</label>
                        { required && <p style={{ fontSize: '12px', fontWeight: '500', color: '#f48181' }}>(Required)</p>}
                    </Row> }
                    { description && <p className="label-container__description">{ description }</p>}
                </List>

                { children }
            </List>
        </div>
    )
}
